
interface BaseCard {
    id: number;
    title: string;
    subTitle: string;
    cardLabel: CardLabel;
    labelIcon: any;
    lastModifiedAt: number;
    url?: string;
};

export interface ThumbnailCard extends BaseCard {
    type: CardType.Thumbnail;
    thumbnailUrl: string;
    placeholderImage: any;
}

export interface IconCard extends BaseCard {
    type: CardType.Icon;
    icon: any;
    hoverIcon: any;
}

export type Card = ThumbnailCard | IconCard;

export enum CardType {
    Thumbnail,
    Icon,
    ViewMore
}

export enum CardLabel {
    Chart = 'Chart',
    Dashboard = 'Dashboard',
    Dataset = 'Dataset',
    Database = 'Database',
}

export enum DropDownOption {
    SqlLab = 'SQL Lab',
    Alerts = 'Alerts & Reports',
    UserList = 'List Users',
    RoleList = 'List Roles',
    RowLevelSecurity = 'Row Level Security',
    ActionLog = 'Activity Logs',
    AnnotationLayers = 'Annotation Layers',
    UserInfo = 'User Info',
    Profile = 'Profile',
    Logout = 'Logout',
}
